const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * Badges Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('Badges', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {
  return $resource(appConfiguration.apiUrl + '/learn/v3/badges/:subresource/:subsubresource/:subsubsubresource', null, {
    create: {params: {subresource: ''}, method: 'POST', isArray: false},
    update: {params: {subresource: ''}, method: 'POST', isArray: false},
    get: {params: {subresource: ''}, method: 'GET', isArray: true},
    find: {params: {subresource: 'search'}, method: 'GET', isArray: true},
    findOne: {params: {subresource: ''}, method: 'GET', isArray: false},
    getAwardedByBadge: {params: {subresource: 'awarded', subsubresource: 'badge'}, method: 'GET', isArray: true},
    getAwardedByUser: {params: {subresource: 'awarded', subsubresource: 'user'}, method: 'GET', isArray: true}
  });
}]);
